import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-3 w-full mt-0" }
const _hoisted_2 = {
  key: 0,
  class: "text-xs text-white text-center"
}
const _hoisted_3 = {
  key: 1,
  class: "text-xs text-white text-center"
}
const _hoisted_4 = {
  key: 0,
  class: "text-xs text-white text-center"
}
const _hoisted_5 = {
  key: 1,
  class: "text-xs text-white text-center"
}
const _hoisted_6 = { class: "relative w-full h-[32rem]" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "flex items-center justify-center w-full h-full"
}

export function render(_ctx, _cache) {
  const _component_PopupMainNavbar = _resolveComponent("PopupMainNavbar")
  const _component_PopupWalletNavbar = _resolveComponent("PopupWalletNavbar")
  const _component_CardWithdraw = _resolveComponent("CardWithdraw")
  const _component_AccordionHeader = _resolveComponent("AccordionHeader")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_AccordionContent = _resolveComponent("AccordionContent")
  const _component_AccordionPanel = _resolveComponent("AccordionPanel")
  const _component_Accordion = _resolveComponent("Accordion")
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PopupMainNavbar),
    _createVNode(_component_PopupWalletNavbar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_CardWithdraw, {
        detail: _ctx.walletUser,
        onWithdraw: _cache[0] || (_cache[0] = () => _ctx.handleWithdraw('walletUser', 0))
      }, null, 8 /* PROPS */, ["detail"]),
      _createVNode(_component_CardWithdraw, {
        detail: _ctx.walletCash,
        onWithdraw: _cache[1] || (_cache[1] = () => _ctx.handleWithdraw('walletCash', 0))
      }, null, 8 /* PROPS */, ["detail"]),
      _createVNode(_component_CardWithdraw, {
        detail: _ctx.walletAffiliate,
        onWithdraw: _cache[2] || (_cache[2] = () => _ctx.handleWithdraw('walletAffiliate', 0))
      }, null, 8 /* PROPS */, ["detail"]),
      (_ctx.walletCommission.active)
        ? (_openBlock(), _createBlock(_component_CardWithdraw, {
            key: 0,
            detail: _ctx.walletCommission,
            onWithdraw: _cache[3] || (_cache[3] = () => _ctx.handleWithdraw('walletCommission', 0))
          }, {
            table: _withCtx(() => [
              _createVNode(_component_Accordion, {
                value: "table",
                pt: {root:'px-0! bg-transparent!'}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_AccordionPanel, {
                    value: "table",
                    pt: {root: 'bg-transparent! border-0!'}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AccordionHeader, { pt: {root: 'py-2.5! bg-transparent! rounded-none!'} }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createElementVNode("span", { class: "flex items-center gap-2 w-full" }, [
                            _createElementVNode("span", { class: "text-white text-sm font-bold whitespace-nowrap" }, "รายละเอียดคอมมิชชั่น")
                          ], -1 /* HOISTED */)
                        ])),
                        _: 1 /* STABLE */,
                        __: [7]
                      }),
                      _createVNode(_component_AccordionContent, { pt: {root: 'p-0!', content: 'bg-transparent!'} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DataTable, {
                            value: _ctx.walletCommission.details,
                            showGridlines: "",
                            scrollable: "",
                            scrollHeight: "100px",
                            size: "small",
                            class: "table-auto w-full",
                            pt: {
									root: '',
									tableContainer: 'border-[#d5be6e]!',
									thead: 'bg-[#ffa010ad]!',
									tbody: 'bg-transparent!',
									bodyRow: 'bg-transparent! border-0!',
									emptyMessage: 'bg-transparent!'
								}
                          }, {
                            empty: _withCtx(() => [
                              false
                                ? (_openBlock(), _createElementBlock("p", _hoisted_2, "กำลังโหลดข้อมูล"))
                                : (_openBlock(), _createElementBlock("p", _hoisted_3, "ไม่พบข้อมูล"))
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                field: "type",
                                header: "ประเภท",
                                "header-class": "text-[10px]",
                                "body-class": "text-xs text-white",
                                pt: {headerCell:'bg-transparent! text-white!'}
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createTextVNode(_toDisplayString(slotProps.data.type), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_Column, {
                                field: "percent",
                                header: "เปอร์เซ็นต์",
                                "header-class": "text-[10px]",
                                "body-class": "text-xs text-white",
                                pt: {headerCell:'bg-transparent! text-white!'}
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createTextVNode(_toDisplayString(slotProps.data.percent), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_Column, {
                                field: "validAmount",
                                header: "ยอดเทิร์น",
                                "header-class": "text-[10px]",
                                "body-class": "text-xs text-white",
                                pt: {headerCell:'bg-transparent! text-white!'}
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createTextVNode(_toDisplayString(_ctx.formatCurrency(slotProps.data.validAmount)), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_Column, {
                                field: "amount",
                                header: "ค่าคอม",
                                "header-class": "text-[10px]",
                                "body-class": "text-xs text-white",
                                pt: {headerCell:'bg-transparent! text-white!'}
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createTextVNode(_toDisplayString(_ctx.formatCurrency(slotProps.data.amount)), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["value"])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["detail"]))
        : _createCommentVNode("v-if", true),
      (_ctx.walletCashback.active)
        ? (_openBlock(), _createBlock(_component_CardWithdraw, {
            key: 1,
            detail: _ctx.walletCashback,
            onWithdraw: _cache[4] || (_cache[4] = () => _ctx.handleWithdraw('walletCashback', 0))
          }, {
            table: _withCtx(() => [
              _createVNode(_component_Accordion, {
                value: "table",
                pt: {root:'px-1.5 bg-transparent!'}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_AccordionPanel, {
                    value: "table",
                    pt: {root: 'bg-transparent! border-0!'}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AccordionHeader, { pt: {root: 'py-2.5! bg-transparent! rounded-none!'} }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createElementVNode("span", { class: "flex items-center gap-2 w-full" }, [
                            _createElementVNode("span", { class: "text-white text-sm font-bold whitespace-nowrap" }, "รายละเอียดแคชแบ็ค")
                          ], -1 /* HOISTED */)
                        ])),
                        _: 1 /* STABLE */,
                        __: [8]
                      }),
                      _createVNode(_component_AccordionContent, { pt: {root: 'p-0!', content: 'bg-transparent!'} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DataTable, {
                            value: _ctx.walletCashback.details,
                            showGridlines: "",
                            scrollable: "",
                            scrollHeight: "100px",
                            size: "small",
                            class: "table-auto w-full",
                            pt: {
									root: '',
									tableContainer: 'border-[#d5be6e]!',
									thead: 'bg-[#ffa010ad]!',
									tbody: 'bg-transparent!',
									bodyRow: 'bg-transparent! border-0!',
									emptyMessage: 'bg-transparent!'
								}
                          }, {
                            empty: _withCtx(() => [
                              false
                                ? (_openBlock(), _createElementBlock("p", _hoisted_4, "กำลังโหลดข้อมูล"))
                                : (_openBlock(), _createElementBlock("p", _hoisted_5, "ไม่พบข้อมูล"))
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                field: "type",
                                header: "ประเภท",
                                "header-class": "text-[10px]",
                                "body-class": "text-xs text-white",
                                pt: {headerCell:'bg-transparent! text-white!'}
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createTextVNode(_toDisplayString(slotProps.data.type), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_Column, {
                                field: "percent",
                                header: "เปอร์เซ็นต์",
                                "header-class": "text-[10px]",
                                "body-class": "text-xs text-white",
                                pt: {headerCell:'bg-transparent! text-white!'}
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createTextVNode(_toDisplayString(slotProps.data.percent), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_Column, {
                                field: "validAmount",
                                header: "ยอดเทิร์น",
                                "header-class": "text-[10px]",
                                "body-class": "text-xs text-white",
                                pt: {headerCell:'bg-transparent! text-white!'}
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createTextVNode(_toDisplayString(_ctx.formatCurrency(slotProps.data.validAmount)), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_Column, {
                                field: "amount",
                                header: "ค่าคอม",
                                "header-class": "text-[10px]",
                                "body-class": "text-xs text-white",
                                pt: {headerCell:'bg-transparent! text-white!'}
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createTextVNode(_toDisplayString(_ctx.formatCurrency(slotProps.data.amount)), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["value"])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["detail"]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_CardWithdraw, {
        detail: _ctx.walletDiamond,
        onWithdraw: _cache[5] || (_cache[5] = () => _ctx.handleWithdraw('walletCash', 0))
      }, null, 8 /* PROPS */, ["detail"])
    ]),
    _createVNode(_component_ConfirmDialog, { group: _ctx.confirmGroup }, null, 8 /* PROPS */, ["group"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[6] || (_cache[6] = $event => ((_ctx.visible) = $event)),
      modal: "",
      style: { width: '25rem' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.iframeUrl)
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 0,
                src: _ctx.iframeUrl,
                class: "w-full h-full"
              }, null, 8 /* PROPS */, _hoisted_7))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_ProgressSpinner, { style: {"width":"36px","height":"36px"} })
              ]))
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible"])
  ], 64 /* STABLE_FRAGMENT */))
}